
import React from "react";
import { Grid } from "../../UI/Grid";
import { Row } from "./Row";
import { Typography } from "../../UI/Typography";
import { useMatchingRoundRows } from "./useMatchingRoundRows";

const NO_ROWS_TEXT_L1 = "This network currently has no Matching Round with a status of: Upcoming, Active, Matching or Closed";
const NO_ROWS_TEXT_L2 = "To create a new Matching Round, please contact clients@roomsync.com";

interface MatchingRoundRowsProps {
  showArchived?: boolean;
}

export const MatchingRoundRows: React.FC<MatchingRoundRowsProps> = ({ showArchived = false }) => {
  const {
    archivedRows,
    currecntNetwork,
    isIntegratedNetwork,
    isLoggedInUsersCard,
    rows,
    stats} = useMatchingRoundRows();

  // Combine rows and archived rows based on showArchived state
  const displayRows = showArchived ? [...rows, ...archivedRows] : rows;

  return (
    <>
      <Grid container item xs={12} mt={2} mb={2} gap={3}>
      {displayRows.map((row, idx) =>
        stats[row.l2Id] && <Grid item xs={12}>
          <Row
            key={row.l2Id + idx}
            stats={stats[row.l2Id]}
            isIntegratedNetwork={isIntegratedNetwork}
            isLoggedInUsersCard={isLoggedInUsersCard}
            apt={currecntNetwork.apt}
            importType={currecntNetwork.importType}
            {...row}/>

        </Grid>)
      }

      {displayRows.length === 0 && <Grid container>
        <Typography align="center" width={"100%"}>{NO_ROWS_TEXT_L1} </Typography>
        <Typography align="center" width={"100%"}>{NO_ROWS_TEXT_L2} </Typography>
      </Grid>}

      </Grid>
    </>
  );
};
